var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPasswordChangeSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 206 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.917 180.25C122.218 180.25 103 161.032 103 137.333C103 113.635 122.218 94.4167 145.917 94.4167C169.624 94.4167 188.833 113.635 188.833 137.333C188.833 161.032 169.624 180.25 145.917 180.25",
    stroke: "#CFE7FC",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.989 127.797L141.145 151.642L126.845 137.333",
    stroke: "#CFE7FC",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3709 66.3921C68.6241 67.6453 68.6241 69.6881 67.3709 70.9413C66.1178 72.1945 64.0749 72.1945 62.8218 70.9413C61.5686 69.6881 61.5686 67.6453 62.8218 66.3921C64.0749 65.1304 66.1092 65.1304 67.3709 66.3921",
    stroke: "#CFE7FC",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.274 66.3921C106.527 67.6453 106.527 69.6881 105.274 70.9413C104.021 72.1945 101.978 72.1945 100.725 70.9413C99.4719 69.6881 99.4719 67.6453 100.725 66.3921C101.978 65.1304 104.021 65.1304 105.274 66.3921",
    stroke: "#CFE7FC",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.187 66.3921C144.441 67.6453 144.441 69.6881 143.187 70.9413C141.934 72.1945 139.891 72.1945 138.638 70.9413C137.385 69.6881 137.385 67.6453 138.638 66.3921C139.891 65.1304 141.926 65.1304 143.187 66.3921",
    stroke: "#CFE7FC",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.25 111.583H42.9167C33.4321 111.583 25.75 103.901 25.75 94.4167V42.9167C25.75 33.4321 33.4321 25.75 42.9167 25.75H163.083C172.568 25.75 180.25 33.4321 180.25 42.9167V68.6667",
    stroke: "#CFE7FC",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordChangeSuccess);
export default __webpack_public_path__ + "static/media/passwordChangeSuccess.626995e461307225710ceaa99de976bb.svg";
export { ForwardRef as ReactComponent };